module.exports = __webpack_public_path__ + "static/media/48386886_2309075045834340_1655160222693457920_o.bfe6daaa.jpg";